import styled from "styled-components/macro";
import type { ElearningTheme } from "themes/elearning.theme";
import type { ButtonProps } from "./Button.model";

interface Props {
  theme: ElearningTheme;
}

type StyledButtonProps = ButtonProps & Props;

export const StyledButton = styled.button<StyledButtonProps>`
  border-color: transparent;
  border-radius: 4px;
  border-style: solid;
  border-width: 1px;
  cursor: pointer;
  font-weight: bold;
  font-size: ${(props: Props) => props.theme.font.size._16};
  outline: none;
  text-align: center;
  min-width: ${(props) => `${props.width}px` || "fit-content"};
  height: ${(props) => `${props.height}px` || "40px"};
  ${(props) =>
    props.variant === "blank" &&
    `
      box-shadow: none;
      background-color: ${props.theme.palette.neutral._10};
      border: 1px solid ${props.theme.palette.neutral._20};
      color: ${props.theme.palette.neutral.black};
      &:hover {
        background-color: ${props.theme.palette.neutral._20};
      }
    `};
  ${(props) =>
    props.variant === "secondary" &&
    `
      box-shadow: none;
      background-color: ${props.theme.palette.secondary._900};
      border: 1px solid ${props.theme.palette.neutral._900};
      color: ${props.theme.palette.neutral.white};
      &:hover {
        background-color: #106aa7;
      }
    `};
    ${(props) =>
      props.variant === "primary" &&
      `
      box-shadow: none;
      background-color: ${props.theme.palette.primary.brand};
      border: 1px solid ${props.theme.palette.primary.brand};
      color: ${props.theme.palette.neutral.white};
      &:hover {
        background-color: #e63c98;
      }
    `};
`;
